/* import __COLOCATED_TEMPLATE__ from './circuitry-area.hbs'; */
import Component from '@ember/component';
import { computed, action } from '@ember/object';
import { service } from '@ember/service';
import utilities from '../utils/utilities';
import { eng3 } from '@ebiz/pretty-num';
import { modifier } from 'ember-modifier';

////////////////////////////////////////////////////////////////////////////////////
// Static functions to Draw Circuit by Loading SVG & then showing/hiding sections //
////////////////////////////////////////////////////////////////////////////////////

var getSize = function () {
  let circuitContainer = document.querySelector('#circuit-container');
  return circuitContainer.clientWidth;
};

var setFontSize = function () {
  var bigger = (getSize() * 0.042 > 17.5 ? 17.5 : getSize() * 0.042) + 'px',
    normal = (getSize() * 0.038 > 15 ? 15 : getSize() * 0.038) + 'px';

  let internalCircuitryLabels = document.querySelectorAll('.internal-circuitry-label');
  let cirPartId = document.querySelector('#cirPartId');

  internalCircuitryLabels.forEach((label) => {
    label.style['font-size'] = normal;
    label.style['line-height'] = normal;
  });
  cirPartId.style['font-size'] = bigger;
  cirPartId.style['line-height'] = bigger;
};

var getSvgDimensions = function () {
  var size = getSize(),
    width = size,
    height = 0.94 * width;

  return [width, height];
};

var setSizes = function () {
  let circuitContainer = document.querySelector('#circuit-container');
  circuitContainer.style.height = `${0.785 * getSize()}px`;
  setFontSize();
};

var hideSection = function (attrib) {
  if (document.getElementById(attrib)) {
    document.getElementById(attrib).style.visibility = 'hidden';
  }
};

var display3AmpSvg = function (isInf, utils, context, isClamped = false) {
  setSizes();

  let svgName = isClamped ? 'threeAmpArchitectureClamped.svg' : 'threeAmpArchitecture.svg',
    className = 'threeamp-diagram';

  if (isClamped) className = className.concat(' clamped');

  utils.loadSvg(svgName, document.querySelector('#svg-circuit-area'), function () {
    var dimensions = getSvgDimensions();
    let svgElement = document.querySelector('#circuit-container svg');
    svgElement.style.width = `${dimensions[0].toString()}px`;
    svgElement.style.height = `${dimensions[1].toString()}px`;
    context.circuitElement.width = `${dimensions[0].toString()}px`;
    context.circuitElement.height = `${dimensions[1].toString()}px`;
    hideSection('RgShortGroup');
    if (!isInf) hideSection('RgOpenGroup');
    else hideSection('RgGroup');
  });
  context.set('opAmpTypeClass', className);
};

var display3AmpFIXEDSvg = function (utils, context) {
  setSizes();
  utils.loadSvg('threeAmpArchitectureFIXEDGAIN.svg', document.querySelector('#svg-circuit-area'), function () {
    var dimensions = getSvgDimensions();
    let svgElement = document.querySelector('#circuit-container svg');
    svgElement.style.width = `${dimensions[0].toString()}px`;
    svgElement.style.height = `${dimensions[1].toString()}px`;
    context.circuitElement.width = `${dimensions[0].toString()}px`;
    context.circuitElement.height = `${dimensions[1].toString()}px`;
  });
  context.set('opAmpTypeClass', 'digpro-diagram');
};

var display3AmpPINSTRAPPEDSvg = function (gains, gain, type, gainType, utils, context) {
  setSizes();
  utils.loadSvg('threeAmpArchitecturePINSTRAPPED.svg', document.querySelector('#svg-circuit-area'), function () {
    var dimensions = getSvgDimensions();
    let svgElement = document.querySelector('#circuit-container svg');
    svgElement.style.width = `${dimensions[0].toString()}px`;
    svgElement.style.height = `${dimensions[1].toString()}px`;
    context.circuitElement.width = `${dimensions[0].toString()}px`;
    context.circuitElement.height = `${dimensions[1].toString()}px`;

    hideSection('RgGroup');
    var smaller = Math.min(gains[0].id, gains[1].id),
      larger = Math.max(gains[0].id, gains[1].id);
    switch (gain.id) {
      case smaller:
        hideSection('RgShortGroup');
        break;
      case larger:
        hideSection('RgOpenGroup');
        break;
      default:
        break;
    }
  });
  context.set('opAmpTypeClass', 'threeamp-diagram');
};

var display3AmpDIGPROSvg = function (utils, context) {
  setSizes();
  utils.loadSvg('threeAmpArchitectureDIGPROGRAM.svg', document.querySelector('#svg-circuit-area'), function () {
    var dimensions = getSvgDimensions();
    let svgElement = document.querySelector('#circuit-container svg');
    svgElement.style.width = `${dimensions[0].toString()}px`;
    svgElement.style.height = `${dimensions[1].toString()}px`;
    context.circuitElement.width = `${dimensions[0].toString()}px`;
    context.circuitElement.height = `${dimensions[1].toString()}px`;
  });
  context.set('opAmpTypeClass', 'digpro-diagram');
};

var display2AmpSvg = function (isPinstrapped, isInf, gains, gain, type, utils, context) {
  setSizes();
  utils.loadSvg('twoAmpArchitecture.svg', document.querySelector('#svg-circuit-area'), function () {
    var dimensions = getSvgDimensions();
    let svgElement = document.querySelector('#circuit-container svg');
    svgElement.style.width = `${dimensions[0].toString()}px`;
    svgElement.style.height = `${dimensions[1].toString()}px`;
    context.circuitElement.width = `${dimensions[0].toString()}px`;
    context.circuitElement.height = `${dimensions[1].toString()}px`;

    if (isPinstrapped) {
      // to deal with pinstrapped 2amp LTC parts
      hideSection('RgTwoAmp');
      hideSection('Rg_OpenTwoAmp');
      hideSection('PinstrappedHide');

      var smaller = Math.min(gains[0].id, gains[1].id),
        larger = Math.max(gains[0].id, gains[1].id);
      switch (
        gain.id // to show/hide pinstrapping
      ) {
        case smaller:
          break;
        case larger:
          hideSection('PinstrappedShow');
          break;
        default:
          break;
      }
    } else if (isInf) {
      hideSection('RgTwoAmp');
      hideSection('PinstrappedShow');
    } else {
      hideSection('Rg_OpenTwoAmp');
      hideSection('PinstrappedShow');
    }
  });
  context.set('opAmpTypeClass', 'twoamp-diagram');
};

var displayCurrentSvg = function (gain, utils, context) {
  setSizes();
  utils.loadSvg('currentArchitecture.svg', document.querySelector('#svg-circuit-area'), function () {
    var dimensions = getSvgDimensions();
    let svgElement = document.querySelector('#circuit-container svg');
    svgElement.style.width = `${dimensions[0].toString()}px`;
    svgElement.style.height = `${dimensions[1].toString()}px`;
    context.circuitElement.width = `${dimensions[0].toString()}px`;
    context.circuitElement.height = `${dimensions[1].toString()}px`;

    if (gain == 1) {
      hideSection('regularGain');
    } else {
      hideSection('oneGain');
    }
  });
  context.set('opAmpTypeClass', 'current-diagram');
};

var displayDiffTIAPGIASvg = function (utils, context) {
  setSizes();
  utils.loadSvg('diffTIAPGIAArchitecture.svg', document.querySelector('#svg-circuit-area'), function () {
    var dimensions = getSvgDimensions();
    let svgElement = document.querySelector('#circuit-container svg');
    svgElement.style.width = `${dimensions[0].toString()}px`;
    svgElement.style.height = `${dimensions[1].toString()}px`;
    context.circuitElement.width = `${dimensions[0].toString()}px`;
    context.circuitElement.height = `${dimensions[1].toString()}px`;

    if (!context.showFirstNegSupply) hideSection('circuitry_firstNegSupply');
  });
  context.set('opAmpTypeClass', 'diffpgia-diagram difftiapgia-diagram');
};

var displayDiff3AmpPGIASvg = function (utils, context) {
  setSizes();
  utils.loadSvg('diff3AmpPGIAArchitecture.svg', document.querySelector('#svg-circuit-area'), function () {
    var dimensions = getSvgDimensions();
    let svgElement = document.querySelector('#circuit-container svg');
    svgElement.style.width = `${dimensions[0].toString()}px`;
    svgElement.style.height = `${dimensions[1].toString()}px`;
    context.circuitElement.width = `${dimensions[0].toString()}px`;
    context.circuitElement.height = `${dimensions[1].toString()}px`;
  });
  context.set('opAmpTypeClass', 'diffpgia-diagram diffthreeamppgia-diagram');
};

////////////////////////////////////////////////////////////////////////////////////
// circuitry-area - Component that displays the Amplifier internal circuitry      //
////////////////////////////////////////////////////////////////////////////////////

export default class CircuitryArea extends Component {
  tagName = '';
  @service intl;
  circuitElement = null;
  boundResizeListener = null;
  circuitErrors = null;
  opAmpTypeClass = '';

  ////////////////////////////////////////////////////////////////////////////////
  // Modifers                                                                   //
  ////////////////////////////////////////////////////////////////////////////////

  /* eslint-disable no-unused-vars */
  insertingCircuit = modifier(
    (
      element,
      [
        _selectedPart,
        _selectedGainInput,
        _currentSignalType,
        _vDiffLeft,
        _vDiffRight,
        _vDiffSlider,
        _varTypeLeft,
        _varTypeRight,
        _varTypeSlider,
        _vref,
        _vsNeg,
        _vsPos,
      ],
    ) => {
      /* eslint-enable no-unused-vars */
      this.set('circuitElement', element);
      this.drawInternalCircuit();

      this.boundResizeListener = this.drawInternalCircuit.bind(this);
      window.addEventListener('resize', this.boundResizeListener);
      this.updateCircuitModel();

      return () => {
        window.removeEventListener('resize', this.boundResizeListener);
        this.set('circuitElement', null);
      };
    },
  );

  setCircuitError = modifier((element) => {
    const size = getSize() * 0.19 + 'px';
    element.style.fontSize = size;
    element.style.lineHeight = size;
  });

  ////////////////////////////////////////////////////////////////////////////////
  // Computed Values                                                            //
  ////////////////////////////////////////////////////////////////////////////////

  @computed('projectData.{vsPos,vsPosIn}') get vsPosOutput() {
    return 'vsPosIn' in this.projectData ? eng3(this.projectData.vsPosIn) : eng3(this.projectData.vsPos);
  }

  @computed('projectData.{vsNeg,vsNegIn}') get vsNegOutput() {
    return 'vsNegIn' in this.projectData ? eng3(this.projectData.vsNegIn) : eng3(this.projectData.vsNeg);
  }

  @computed('projectData.{vsPos,vsPosOut}') get vsPosOutOutput() {
    return 'vsPosOut' in this.projectData ? eng3(this.projectData.vsPosOut) : null;
  }

  @computed('projectData.{vsNeg,vsNegOut}') get vsNegOutOutput() {
    return 'vsNegOut' in this.projectData ? eng3(this.projectData.vsNegOut) : null;
  }

  @computed('vref') get vrefOutput() {
    return eng3(this.vref);
  }

  @computed('projectData.vclhi') get vclhiOutput() {
    return 'vclhi' in this.projectData ? eng3(this.projectData.vclhi) : null;
  }

  @computed('projectData.vcllo') get vclloOutput() {
    return 'vcllo' in this.projectData ? eng3(this.projectData.vcllo) : null;
  }

  @computed('projectData.vref2') get vref2Output() {
    return 'vref2' in this.projectData ? eng3(this.projectData.vref2) : null;
  }

  @computed('projectData.vref1') get vref1Output() {
    return 'vref1' in this.projectData ? eng3(this.projectData.vref1) : null;
  }

  @computed('validationResults.isAllValid') get isCircuitVisible() {
    return this.validationResults.isAllValid;
  }

  @computed('validationResults.isIntrnCircuit') get isCircuitInValid() {
    return !this.validationResults.isIntrnCircuit;
  }

  @computed('circuitErrors.fields') get negVinValid() {
    return !(this.circuitErrors && this.circuitErrors.fields.includes('negVinResult'));
  }

  @computed('circuitErrors.fields') get posVinValid() {
    return !(this.circuitErrors && this.circuitErrors.fields.includes('posVinResult'));
  }

  @computed('circuitErrors.fields') get negVinGainValid() {
    return !(this.circuitErrors && this.circuitErrors.fields.includes('negVinGainResult'));
  }

  @computed('circuitErrors.fields') get posVinGainValid() {
    return !(this.circuitErrors && this.circuitErrors.fields.includes('posVinGainResult'));
  }

  @computed('circuitErrors.fields') get negVinGain2AmpValid() {
    return !(this.circuitErrors && this.circuitErrors.fields.includes('negVinGain2AmpResult'));
  }

  @computed('circuitErrors.fields') get vdiffCurrentValid() {
    return !(this.circuitErrors && this.circuitErrors.fields.includes('vdiffCurrentResult'));
  }

  @computed('circuitErrors.fields') get vfbValid() {
    return !(this.circuitErrors && this.circuitErrors.fields.includes('vfbResult'));
  }

  @computed('circuitErrors.fields') get cirPosVOutValid() {
    return !(this.circuitErrors && this.circuitErrors.fields.includes('cirPosVOutResult'));
  }

  @computed('circuitErrors.fields') get subtractInValid() {
    return !(this.circuitErrors && this.circuitErrors.fields.includes('subtractInResult'));
  }

  @computed('circuitErrors.fields') get cirNegVOutValid() {
    return !(this.circuitErrors && this.circuitErrors.fields.includes('cirNegVOutResult'));
  }

  @computed('circuitErrors.fields') get cirVOutValid() {
    return !(this.circuitErrors && this.circuitErrors.fields.includes('cirVOutResult'));
  }

  @computed('circuitErrors.fields') get cirPreAmpOutPosValid() {
    return !(this.circuitErrors && this.circuitErrors.fields.includes('cirPreAmpOutPos'));
  }

  @computed('circuitErrors.fields') get cirPreAmpOutNegValid() {
    return !(this.circuitErrors && this.circuitErrors.fields.includes('cirPreAmpOutNeg'));
  }

  @computed('circuitErrors.fields') get cirGainAmpPosValid() {
    return !(this.circuitErrors && this.circuitErrors.fields.includes('cirGainAmpPos'));
  }

  @computed('circuitErrors.fields') get cirGainAmpNegValid() {
    return !(this.circuitErrors && this.circuitErrors.fields.includes('cirGainAmpNeg'));
  }

  ////////////////////////////////////////////////////////////////////////////////
  // User Functions                                                             //
  ////////////////////////////////////////////////////////////////////////////////

  drawInternalCircuit() {
    let s = this.selectedPart;
    switch (this.selectedDiagram) {
      case 1:
        display3AmpSvg(this.rgInf, utilities, this, this.isThreeAmpClampedSchematic);
        break;
      case 2:
        display3AmpDIGPROSvg(utilities, this);
        break;
      case 3:
        display2AmpSvg(
          s.diagramType.toUpperCase() === 'PINSTRAPPED',
          this.rgInf,
          s.gainInputs,
          s.selectedGainInput,
          s.gainType.toLowerCase(),
          utilities,
          this,
        );
        break;
      case 4:
        displayCurrentSvg(s.selectedGainInput.id, utilities, this);
        break;
      case 5:
        display3AmpPINSTRAPPEDSvg(
          s.gainInputs,
          s.selectedGainInput,
          s.diagramType.toUpperCase(),
          s.gainType.toLowerCase(),
          utilities,
          this,
        );
        break;
      case 6:
        display3AmpFIXEDSvg(utilities, this);
        break;
      case 7:
        displayDiffTIAPGIASvg(utilities, this);
        break;
      case 8:
        displayDiff3AmpPGIASvg(utilities, this);
        break;
    }
  }

  ////////////////////////////////////////////////////////////////////////////////
  // Component Actions                                                          //
  ////////////////////////////////////////////////////////////////////////////////

  @action updateSlider(fieldName, fieldValue) {
    this.set('projectData.' + fieldName, fieldValue);
    if (this.updateCircuitModel) {
      this.updateCircuitModel();
    }
  }
}
